<template>
  <div class="po-input-field">
    <wo-label v-if="inputLabel" :for="name">{{ inputLabel }}</wo-label>
    <wo-input-field :id="name" :name="name" :placeholder="inputPlaceholder" :type="type" v-model="inputValue" mod-block v-bind="modProps" :autocomplete="autocomplete"></wo-input-field>
    <wo-form-message v-if="inputMessage">{{ inputMessage }}</wo-form-message>
  </div>
</template>

<script>

import _ from 'lodash'
import modProps from '@/mixins/mod-props'

export default {
  name: 'PoInputField',
  mixins: [ modProps ],
  props: {
    value: [String, Number, Object],
    name: String,
    type: { type: String, default: 'text' },
    debounce: Boolean,
    labelKey: String,
    label: String,
    placeholderKey: String,
    placeholder: String,
    message: String,
    messageKey: String,
    autocomplete: String
  },
  data () {
    return {
      inputValue: undefined
    }
  },
  computed: {
    inputLabel () {
      return this.label || this.$t(this.labelKey)
    },
    inputPlaceholder () {
      return this.placeholder || this.$t(this.placeholderKey)
    },
    inputMessage () {
      return this.message || this.$t(this.messageKey)
    }
  },
  watch: {
    value () { this.applyValue() },
    inputValue () { this.inputUpdated() }
  },
  created () {
    this.applyValue()
  },
  methods: {
    applyValue () {
      this.inputValue = this.value
    },
    inputUpdated () {
      if (this.debounce) {
        this.emitDebounced()
      } else {
        this.emitValue()
      }
    },
    emitValue () {
      this.$emit('input', this.inputValue)
    },
    emitDebounced: _.debounce(function () { this.emitValue() }, 500)
  }
}
</script>
<style lang="scss">
  .po-input-field {
    margin-bottom: 15px;

    .wo-input-field+.wo-form-message {
      margin-top: -15px;
      margin-bottom: 15px;
    }
  }

  .wo-properties__value {
    .po-input-field:last-child {
      margin-bottom: 0;
    }
  }
</style>
